"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AmountSlider = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _Slider = _interopRequireDefault(require("@material-ui/core/Slider"));

var _fearless = require("@zip/react-icons/fearless");

var css = _interopRequireWildcard(require("./AmountSlider.styles"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var BasicSlider = function BasicSlider(_ref) {
  var _ref$marks = _ref.marks,
      marks = _ref$marks === void 0 ? false : _ref$marks,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 100 : _ref$max,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      props = _objectWithoutProperties(_ref, ["marks", "max", "min"]);

  return (0, _jsxRuntime.jsx)(_Slider["default"], _objectSpread({
    css: css.slider,
    "data-color": "primary",
    marks: Array.isArray(marks) ? marks.map(function (mark) {
      return {
        value: mark
      };
    }) : marks,
    max: max,
    min: min
  }, props));
};

var AmountSlider = function AmountSlider(_ref2) {
  var _ref2$marks = _ref2.marks,
      marks = _ref2$marks === void 0 ? false : _ref2$marks,
      _ref2$max = _ref2.max,
      max = _ref2$max === void 0 ? 100 : _ref2$max,
      _ref2$min = _ref2.min,
      min = _ref2$min === void 0 ? 0 : _ref2$min,
      _onChange = _ref2.onChange,
      _ref2$step = _ref2.step,
      step = _ref2$step === void 0 ? 10 : _ref2$step,
      _ref2$value = _ref2.value,
      value = _ref2$value === void 0 ? 0 : _ref2$value,
      _ref2$valueLabelDispl = _ref2.valueLabelDisplay,
      valueLabelDisplay = _ref2$valueLabelDispl === void 0 ? 'on' : _ref2$valueLabelDispl,
      props = _objectWithoutProperties(_ref2, ["marks", "max", "min", "onChange", "step", "value", "valueLabelDisplay"]);

  return (0, _jsxRuntime.jsx)(_Slider["default"], _objectSpread({
    css: css.slider,
    "data-color": "secondary",
    "data-is-minimum": Number(value) <= min || Array.isArray(marks) && value === marks[0],
    marks: Array.isArray(marks) ? marks.map(function (mark) {
      return {
        value: mark
      };
    }) : marks,
    max: max,
    min: step,
    step: step,
    onChange: function onChange(event, newValue) {
      return Number(newValue) >= min && _onChange(event, newValue);
    },
    value: value,
    valueLabelDisplay: valueLabelDisplay,
    valueLabelFormat: function valueLabelFormat(currentValue) {
      if (currentValue === max) {
        return (0, _jsxRuntime.jsx)("span", {
          css: {
            display: 'flex'
          },
          children: (0, _jsxRuntime.jsx)(_fearless.Celebrate, {
            css: {
              height: 24,
              width: 24
            }
          })
        });
      }

      if (Array.isArray(marks) && currentValue > marks[0] && currentValue < max) {
        return (0, _jsxRuntime.jsx)("span", {
          css: {
            display: 'flex'
          },
          children: (0, _jsxRuntime.jsx)(_fearless.FaceWink, {
            css: {
              height: 24,
              width: 24
            }
          })
        });
      }

      return (0, _jsxRuntime.jsx)("span", {
        css: {
          display: 'flex'
        },
        children: (0, _jsxRuntime.jsx)(_fearless.FaceSmile, {
          css: {
            height: 24,
            width: 24
          }
        })
      });
    }
  }, props));
};

exports.AmountSlider = AmountSlider;
var _default = BasicSlider;
exports["default"] = _default;